import React, { useEffect, useState } from "react";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import axios from "axios";
import * as moment from "moment";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
function EditRider(props) {
  var history = useHistory();
  const [riderData, setRiderData] = useState([]);
  const [riderFname, setRiderFname] = useState("");
  const [ridervehicleTYpe, setRidervehicleTYpe] = useState("");
  const [riderLname, setRiderLname] = useState("");
  const [riderFathername, setRiderFathername] = useState("");
  const [riderDOB, setRiderDOB] = useState("");
  const [riderEmail, setRiderEmail] = useState("");
  const [riderVehicleNo, setRiderVehicleNo] = useState("");
  const [riderVehicleKey, setRiderVehicleKey] = useState("");
  const [riderAddress, setRiderAddress] = useState("");
  const [riderIfsc, setRiderIfsc] = useState("");
  const [RiderVehicleType, setRiderVehicleType] = useState("");
  const [RiderVehicleCategory, setRiderVehicleCategory] = useState("");
  const [riderIdProofImage, setriderIdProofImage] = useState([]);
  const [riderProfile, setRiderProfile] = useState([]);
  const [riderVechicleRCImages, setriderVechicleRCImages] = useState([]);
  const [riderDLImages, setriderDLImages] = useState([]);
  const [riderVechicleImages, setriderVechicleImages] = useState([]);
  const [picture, setPicture] = useState(null);
  const [pictureName, setPictureName] = useState("");
  const [imgData, setImgData] = useState(null);
  const [dlImg, setDlImg] = useState(null);
  const [dlImg2, setDlImg2] = useState(null);
  const [rcImg, setRcImg] = useState(null);
  const [rcImg2, setRcImg2] = useState(null);
  const [idImg, setIdImg] = useState(null);
  const [idImg2, setIdmg2] = useState(null);
  const [uploadId, setUploadId] = useState("");
  const [vehicleImg, setVehicleImg] = useState("");
  const [riderPhone, setRiderPhone] = useState(null);
  const [show, setShow] = useState(false);
  const [nameObject, setNameObject] = useState("");
  const [viewimage, setViewImage] = useState();
  const { id,val } = props.match.params;
  const twoWheeler = ["Bike"];  
  const threeWheeler = ["3 Wheeler"];
  const car = ["SUV/MUV", "Sedan", "Hatch Back"];
  const truck = ["Tata Ace", "PickUp 8ft", "Tata 407"];
  const auto = ["Auto"];
  function getRiderData() {
    axios
      .get(Baseurl.baseurl +
        `/rider/get-rider-details/${id}`)
      .then((res) => {
        
        console.log("dndndnnd",res.data.rider.riderFirstName)
          // var vals = res.data.rider.riderDOB.split("|");
          // var day = parseInt(vals[0]);
          // var month = parseInt(vals[1]);
          // var year = parseInt(vals[2]);
          // const d = new Date(year, month - 1, day);
          // setRiderDOB(moment(d).format("YYYY-MM-DD"));
          setRiderData(res.data.rider);
          setRiderVehicleKey(res.data.rider.riderVechicleImagesKey);
          setRiderVehicleType(res.data.rider.RiderVehicleType.name);
          setRiderVehicleCategory(res.data.rider.RiderVehicleType.category);
          setriderIdProofImage(res.data.rider.riderIdProofImage);
          setriderVechicleRCImages(res.data.rider.riderVechicleRCImages);
          setriderDLImages(res.data.rider.riderDLImages);
          setriderVechicleImages(res.data.rider.riderVechicleImages);
          setRiderPhone(res.data.rider.riderPhone);
          setRiderProfile(res.data.rider.riderProfileImage);
          setRiderFname(res.data.rider.riderFirstName);
          setRiderLname(res.data.rider.riderLastName);
          setRiderFathername(res.data.rider.riderFatherName);
          setRiderEmail(res.data.rider.riderEmail);
          setRiderVehicleNo(res.data.rider.riderVechicleNumber);
          setRiderAddress(res.data.rider.riderCompleteAddress);
          if (res.data.rider.RiderVehicleType.rent == true) {
            setRidervehicleTYpe("Rental");
          } else {
            setRidervehicleTYpe("Owned");
          }
        
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  useEffect(() => {
    getRiderData();
  }, []);
  const onChangePicture = (e, id) => {
    setUploadId(id);
    if (e.target.files[0] && e.target.files[0].size / 1048576 < 3) {
      if (e.target.files[0]) {
        setPicture(e.target.files[0]);
        setPictureName(e.target.files[0].name);
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          if (id === "prof") {
            setImgData(reader.result);
          }
          if (id === "dl1") {
            setDlImg(reader.result);
          }
          if (id === "dl2") {
            setDlImg2(reader.result);
          }
          if (id === "rc1") {
            setRcImg(reader.result);
          }
          if (id === "rc2") {
            setRcImg2(reader.result);
          }
          if (id === "id1") {
            setIdImg(reader.result);
          }
          if (id === "id2") {
            setIdmg2(reader.result);
          }
          // if (id === "vehicle" && vehicleImg.length < 5) {
          //   setVehicleImg([...vehicleImg, reader.result]);
          // } else {
          //   swal("Oops", "Cannot upload more than 5 images", "error", {
          //     button: "Done",
          //   });
          // }
          if (id === "vehicle") {
            setVehicleImg(reader.result);
          }
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
    }
  };
  function updateDlImage() {
    const data = new FormData();
    if (uploadId === "dl1") {
      data.append("img", riderDLImages[0]);
      data.append("key", riderData.riderDLImagesKey[0]);
    }
    if (uploadId === "dl2") {
      data.append("img", riderDLImages[1]);
      data.append("key", riderData.riderDLImagesKey[1]);
    }
    data.append("image", picture);
    if (picture) {
      var config = {
        method: "put",
        url: `${Baseurl.baseurl}/rider/update-rider-dl-photo/${id}`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.status) {
            swal("Driving Licience Updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            getRiderData();
            setDlImg(null);
            setDlImg2(null);
            setPicture(null);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "please choose a file to upload", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  }

  function updateRCImage() {
    const data = new FormData();
    if (uploadId === "rc1") {
      data.append("img", riderVechicleRCImages[0]);
      data.append("key", riderData.riderVechicleRCImagesKey[0]);
    }
    if (uploadId === "rc2") {
      data.append("img", riderVechicleRCImages[1]);
      data.append("key", riderData.riderVechicleRCImagesKey[1]);
    }
    data.append("image", picture);
    if (picture) {
      var config = {
        method: "put",
        url: `${Baseurl.baseurl}/rider/update-rider-rc-photo/${id}`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.status) {
            swal(
              "Registration Certificate Updated",
              response.data.message,
              "success",
              {
                button: "Done",
                timer: 1000,
              }
            );
            getRiderData();
            setRcImg(null);
            setRcImg2(null);
            setPicture(null);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "please choose a file to upload", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  }

  function updateIDImage() {
    const data = new FormData();
    if (uploadId === "id1") {
      data.append("img", riderIdProofImage[0]);
      data.append("key", riderData.riderIdProofImageKey[0]);
    }
    if (uploadId === "id2") {
      data.append("img", riderIdProofImage[1]);
      data.append("key", riderData.riderIdProofImageKey[1]);
    }
    data.append("image", picture);
    if (picture) {
      var config = {
        method: "put",
        url: `${Baseurl.baseurl}/rider/update-rider-id-proof/${id}`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.status) {
            swal("Identity Proof Updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            getRiderData();
            setIdImg(null);
            setIdmg2(null);
            setPicture(null);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "please choose a file to upload", "error", {
        button: "Done",
        timer: 1000,
      });
    }
  }

  function updateVehicleImage(val, key) {
    const data = new FormData();
    riderVehicleKey.map((value, idx) => {
      if (idx === key) {
        data.append("key", value);
      }
    });

    data.append("img", val);
    data.append("image", picture);
    if (picture) {
      var config = {
        method: "put",
        url: `${Baseurl.baseurl}/rider/update-rider-vehicle-photo-update/${id}`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.status) {
            swal("Vehicle Image Updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            getRiderData();
            setVehicleImg(null);
            setPicture(null);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      swal("Oops", "please choose a file to update", "error", {
        button: "Done",
      });
    }
  }
  function updateMobileNumber() {
    let number = {
      phone: parseInt(riderPhone),
    };
    axios
      .put(Baseurl.baseurl + `/rider/update-rider-phone/${id}`, number)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getRiderData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }

  function updateFields(e) {
    e.preventDefault();
    let type = ridervehicleTYpe === "Owned" ? false : true;
    let details = {
      riderFirstName: riderFname,
      riderLastName: riderLname,
      riderFatherName: riderFathername,
      riderDOB: riderDOB,
      riderEmail: riderEmail,
      riderVechicleNumber: riderVehicleNo,
      riderCompleteAddress: riderAddress,
      rent: type,
      name: RiderVehicleType,
      category: RiderVehicleCategory,
    };
    axios
      .put(Baseurl.baseurl + `/rider/update-rider-detail/${id}`, details)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getRiderData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }

  function viewImage(img) {
    setShow(true);
    setViewImage(img);
  }
  // function updateProfile() {
  //   const data = new FormData();
  //   data.append("image", riderProfile);
  //   data.append("img", picture);
  //   if (picture) {
  //     var config = {
  //       method: "put",
  //       url: `${Baseurl.baseurl}/rider/rider-profile-update/${id}`,
  //       data: data,
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response.data.status) {
  //           swal("Profile Updated", response.data.message, "success", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //           getRiderData();
  //           setImgData(null);
  //           setPicture(null);
  //         } else {
  //           swal("Oops", response.data.message, "error", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } else {
  //     swal("Oops", "please choose a file to upload", "error", {
  //       button: "Done",
  //     });
  //   }
  // }
  // function addProfile() {
  //   const data = new FormData();
  //   data.append("img", picture);
  //   if (picture) {
  //     var config = {
  //       method: "post",
  //       url: `${Baseurl.baseurl}/rider/add-rider-profile/${id}`,
  //       data: data,
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response.data.status) {
  //           swal("Profile Added", response.data.message, "success", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //           getRiderData();
  //           setImgData(null);
  //           setPicture(null);
  //         } else {
  //           swal("Oops", response.data.message, "error", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } else {
  //     swal("Oops", "please choose a file to upload", "error", {
  //       button: "Done",
  //     });
  //   }
  // }
  // function deleteId(ids) {
  //   if (ids === "id1") {
  //     var idimages = {
  //       image: riderIdProofImage[0],
  //     };
  //   }
  //   if (ids === "id2") {
  //     var idimages = {
  //       image: riderIdProofImage[1],
  //     };
  //   }
  //   axios
  //     .put(Baseurl.baseurl + `/rider/delete-rider-id-proof/${id}`, idimages)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal(
  //           "Identity Proof Image Deleted",
  //           response.data.message,
  //           "success",
  //           {
  //             button: "Done",
  //             timer: 1000,
  //           }
  //         );
  //         getRiderData();
  //         setIdImg(null);
  //         setIdmg2(null);
  //         setPicture(null);
  //       } else {
  //         getRiderData();
  //         swal("Oops", response.data.message, "error", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //       }
  //     });
  // }
  // function addIDImage() {
  //   const data = new FormData();
  //   data.append("img", picture);
  //   if (picture) {
  //     var config = {
  //       method: "put",
  //       url: `${Baseurl.baseurl}/rider/add-rider-id-proof/${id}`,
  //       data: data,
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response.data.status) {
  //           swal("Identity Proof Added", response.data.message, "success", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //           getRiderData();
  //           setIdImg(null);
  //           setIdmg2(null);
  //           setPicture(null);
  //         } else {
  //           swal("Oops", response.data.message, "error", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } else {
  //     swal("Oops", "please choose a file to upload", "error", {
  //       button: "Done",
  //       timer: 1000,
  //     });
  //   }
  // }
  // function addVehicleImage() {
  //   if (riderData.riderVechicleImages.length < 6) {
  //     const data = new FormData();
  //     data.append("img", picture);
  //     if (picture) {
  //       var config = {
  //         method: "put",
  //         url: `${Baseurl.baseurl}/rider/add-rider-vehicle/${id}`,
  //         data: data,
  //       };

  //       axios(config)
  //         .then(function (response) {
  //           if (response.data.status) {
  //             swal("Vehicle image Added", response.data.message, "success", {
  //               button: "Done",
  //               timer: 1000,
  //             });
  //             getRiderData();
  //             setVehicleImg(null);
  //             setPicture(null);
  //           } else {
  //             swal("Oops", response.data.message, "error", {
  //               button: "Done",
  //               timer: 1000,
  //             });
  //           }
  //         })
  //         .catch(function (error) {
  //           console.log(error);
  //         });
  //     } else {
  //       swal("Oops", "please choose a file to upload", "error", {
  //         button: "Done",
  //         timer: 1000,
  //       });
  //     }
  //   } else {
  //     swal("Oops", "cannot enter more than 6 images", "error", {
  //       button: "Done",
  //       timer: 1000,
  //     });
  //   }
  // }
  // function deleteVehicleImage(val) {
  //   var vImages = {
  //     image: `${val}`,
  //   };
  //   axios
  //     .put(Baseurl.baseurl + `/rider/delete-rider-vehicle/${id}`, vImages)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal("Vehicle Image Deleted", response.data.message, "success", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //         getRiderData();
  //         setVehicleImg(null);
  //         setPicture(null);
  //       } else {
  //         getRiderData();
  //         swal("Oops", response.data.message, "error", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //       }
  //     });
  // }
  // function deleteDl(ids) {
  //   if (ids === "dl1") {
  //     var dlimages = {
  //       image: riderDLImages[0],
  //     };
  //   }
  //   if (ids === "dl2") {
  //     var dlimages = {
  //       image: riderDLImages[1],
  //     };
  //   }
  //   axios
  //     .put(Baseurl.baseurl + `/rider/delete-rider-dl/${id}`, dlimages)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal("Driving Licience Deleted", response.data.message, "success", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //         getRiderData();
  //         setDlImg(null);
  //         setDlImg2(null);
  //         setPicture(null);
  //       } else {
  //         getRiderData();
  //         swal("Oops", response.data.message, "error", {
  //           button: "Done",
  //           timer: 1000,
  //         });
  //       }
  //     });
  // }
  // function AddDlImage() {
  //   const data = new FormData();
  //   data.append("img", picture);
  //   if (picture) {
  //     var config = {
  //       method: "put",
  //       url: `${Baseurl.baseurl}/rider/add-rider-dl/${id}`,
  //       data: data,
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response.data.status) {
  //           swal("Driving Licience Added", response.data.message, "success", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //           getRiderData();
  //           setDlImg(null);
  //           setDlImg2(null);
  //           setPicture(null);
  //         } else {
  //           swal("Oops", response.data.message, "error", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } else {
  //     swal("Oops", "please choose a file to upload", "error", {
  //       button: "Done",
  //       timer: 1000,
  //     });
  //   }
  // }

  // function addRCImage() {
  //   const data = new FormData();
  //   data.append("img", picture);
  //   if (picture) {
  //     var config = {
  //       method: "put",
  //       url: `${Baseurl.baseurl}/rider/add-rider-rc/${id}`,
  //       data: data,
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response.data.status) {
  //           swal(
  //             "Registration Certificate Added",
  //             response.data.message,
  //             "success",
  //             {
  //               button: "Done",
  //               timer: 1000,
  //             }
  //           );
  //           getRiderData();
  //           setRcImg(null);
  //           setRcImg2(null);
  //           setPicture(null);
  //         } else {
  //           swal("Oops", response.data.message, "error", {
  //             button: "Done",
  //             timer: 1000,
  //           });
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   } else {
  //     swal("Oops", "please choose a file to upload", "error", {
  //       button: "Done",
  //       timer: 1000,
  //     });
  //   }
  // }
  // function deleteRc(ids) {
  //   if (ids === "rc1") {
  //     var rcImages = {
  //       image: riderVechicleRCImages[0],
  //     };
  //   }
  //   if (ids === "rc2") {
  //     var rcImages = {
  //       image: riderVechicleRCImages[1],
  //     };
  //   }
  //   axios
  //     .put(Baseurl.baseurl + `/rider/delete-rider-rc/${id}`, rcImages)
  //     .then((response) => {
  //       if (response.data.status) {
  //         swal(
  //           "Registration Certificate Deleted",
  //           response.data.message,
  //           "success",
  //           {
  //             button: "Done",
  //           }
  //         );
  //         getRiderData();
  //         setRcImg(null);
  //         setRcImg2(null);
  //         setPicture(null);
  //       } else {
  //         getRiderData();
  //         swal("Oops", response.data.message, "error", { button: "Done" });
  //       }
  //     });
  // }
  return (
    <div className="row">
      {/* <FileUpload /> */}
      <div className="col-lg-12">
        <Modal
          size="lg"
          show={show}
          onHide={() => {
            setShow(false);
          }}
        >
          <Modal.Body>
            <div>
              <img
                alt=""
                style={{
                  resizeMode: "cover",
                  width: "100%",
                  height: "100%",
                }}
                className="playerProfilePic_home_tile"
                src={viewimage}
              />
            </div>
          </Modal.Body>
        </Modal>
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <h4 className="card-title text-white">Edit Rider Details</h4>
            <button
              className="btn btn-primary"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          </div>

          <div className="card-body">
            <div
              className="profile-photo"
              onClick={() => {
                viewImage(riderData.riderProfileImage);
              }}
            >
              <img
                src={riderData.riderProfileImage}
                className="img-fluid rounded-circle"
                alt="profile"
                style={{ height: "100px", width: "100px" }}
              />
            </div>
            <div className="form-validation mt-3">
              <form
                className="form-valide"
                action="#"
                method="post"
                onSubmit={(e) => {
                  updateFields(e);
                }}
              >
                <div className="row">
                  <div className="col-xl-6">
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-username"
                      >
                        First Name
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          id="val-username"
                          name="val-username"
                          defaultValue={riderFname}
                        
                          onChange={(event) => {
                            setRiderFname(event.target.value);
                          }}
                          placeholder="Enter Firstname"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-email"
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          id="val-email"
                          name="val-email"
                          defaultValue={riderLname}
                          onChange={(event) => {
                            setRiderLname(event.target.value);
                          }}
                          placeholder="Enter Lastname"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-password"
                      >
                        Father's Name
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          id="val-password"
                          name="val-password"
                          defaultValue={riderFathername}
                          onChange={(event) => {
                            setRiderFathername(event.target.value);
                          }}
                          placeholder="Enter Father's name"
                        />
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-suggestions"
                      >
                        Date of Birth <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="date"
                          className="form-control"
                          placeholder={riderDOB}
                          value={riderDOB}
                          onChange={(event) => {
                            setRiderDOB(event.target.value);
                          }}
                        ></input>
                      </div>
                    </div> */}
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-skill"
                      >
                        Vehicle Category
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <select
                          multiple={false}
                          className="form-control"
                          id="val-skill"
                          name="val-skill"
                          value={RiderVehicleCategory}
                          onChange={(event) => {
                            setRiderVehicleCategory(event.target.value);
                            if (event.target.value === "two-wheeler") {
                              setNameObject(twoWheeler);
                            } else if (event.target.value === "car") {
                              setNameObject(car);
                            } else if (event.target.value === "truck") {
                              setNameObject(truck);
                            } else if (event.target.value === "3 Wheeler") {
                              setNameObject(threeWheeler);
                            } else {
                              setNameObject(auto);
                            }
                          }}
                        >
                          <option selected={true} disabled="disabled">
                            {RiderVehicleCategory}
                          </option>
                          <option value="two-wheeler">Two Wheeler</option>
                          <option value="3 Wheeler">3 Wheeler</option>
                          <option value="car">Car</option>
                          <option value="truck">Truck</option>
                          <option value="auto">Auto</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-skill"
                      >
                        Vehicle Type
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <select
                          multiple={false}
                          className="form-control"
                          id="val-skill"
                          name="val-skill"
                          value={RiderVehicleType}
                          onChange={(event) => {
                            setRiderVehicleType(event.target.value);
                          }}
                        >
                          <option selected={true} disabled="disabled">
                            {RiderVehicleType}
                          </option>
                          {nameObject &&
                            nameObject.map((val) => (
                              <option value={val}>{val}</option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        style={{ opacity: 0.6 }}
                        className="col-lg-5 col-form-label"
                        htmlFor="val-number"
                      >
                        IFSC Code <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        <input
                          style={{ opacity: 0.7 }}
                          type="text"
                          className="form-control"
                          id="val-number"
                          name="val-number"
                          placeholder="IFxxxxxxxxxxx"
                          readOnly={true}
                          value={
                            riderData.RiderBankAccountDetails &&
                            riderData.RiderBankAccountDetails.RiderAccountIFSC
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-currency"
                      >
                        Vehcile No.
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-7">
                        <input
                          type="text"
                          className="form-control"
                          id="val-currency"
                          name="val-currency"
                          placeholder="XXXX XX XXXX"
                          defaultValue={riderVehicleNo}
                          onChange={(event) => {
                            setRiderVehicleNo(event.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-range"
                      >
                        Address
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-7">
                        <textarea
                          type="text"
                          className="form-control"
                          id="val-range"
                          rows="4"
                          name="val-range"
                          defaultValue={riderAddress}
                          onChange={(event) => {
                            setRiderAddress(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-phoneus"
                      >
                        Email Address
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-7">
                        <input
                          type="email"
                          className="form-control"
                          id="val-phoneus"
                          name="val-phoneus"
                          placeholder="xxxxxxxxx@example.com"
                          defaultValue={riderEmail}
                          onChange={(event) => {
                            setRiderEmail(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-lg-5 col-form-label"
                        htmlFor="val-skill"
                      >
                        Vehicle Own Type
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-7">
                        <select
                          multiple={false}
                          className="form-control"
                          id="val-skill"
                          name="val-skill"
                          value={ridervehicleTYpe}
                          onChange={(event) => {
                            setRidervehicleTYpe(event.target.value);
                          }}
                        >
                          <option selected={true} disabled="disabled">
                            {ridervehicleTYpe}
                          </option>
                          {ridervehicleTYpe === "Owned" && (
                            <option value="Rental">Rental</option>
                          )}
                          {ridervehicleTYpe === "Rental" && (
                            <option value="Owned">Owned</option>
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        style={{ opacity: 0.6 }}
                        className="col-lg-5 col-form-label"
                        htmlFor="val-digits"
                      >
                        Bank A/c no. <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-7">
                        <input
                          style={{ opacity: 0.7 }}
                          readOnly={true}
                          type="number"
                          className="form-control"
                          id="val-digits"
                          name="val-digits"
                          placeholder="xxxxxxxxxxxxxxxx"
                          value={
                            riderData.RiderBankAccountDetails &&
                            riderData.RiderBankAccountDetails.RiderAccountNumber
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-12  ml-auto">
                    <button
                      type="submit"
                      className="btn btn-primary float-right"
                    >
                      Submit
                    </button>
                  </div>
                </div>
                <div className="row mb-5 mt-5">
                  <div className="col-xl-6">
                    <div className="row">
                      <div className="col-lg-5">
                        <label
                          className="col-form-label"
                          htmlFor="val-confirm-password"
                        >
                          Contact No. <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="number"
                          className="form-control"
                          id="val-confirm-password"
                          name="val-confirm-password"
                          value={parseInt(riderPhone)}
                          maxLength={10}
                          onChange={(event) => {
                            setRiderPhone(event.target.value);
                          }}
                          placeholder="95XXXXXXXX"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <button
                      onClick={() => {
                        updateMobileNumber();
                      }}
                      className="btn btn-primary"
                    >
                      update
                    </button>
                  </div>
                </div>
                {/* <div className="row mb-5">
                  <div className="col-sm-2">
                    <label className=" col-form-label" htmlFor="val-range">
                      Profile Picture
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-3">
                    <div className="register_profile_image">
                      <input
                        className="col-sm-12"
                        id="profilePic"
                        type="file"
                        onChange={(e) => {
                          onChangePicture(e, "prof");
                        }}
                      />
                    </div>
                    {(riderData.riderProfileImage || imgData) && (
                      <div
                        onClick={() => {
                          viewImage(riderData.riderProfileImage);
                        }}
                        className="previewProfilePic mt-2"
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                      >
                        <img
                          alt=""
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          className="playerProfilePic_home_tile"
                          src={
                            imgData == null
                              ? riderData.riderProfileImage
                              : imgData
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="mt-3">
                    {riderData.riderProfileImage ? (
                      <button
                        onClick={() => {
                          updateProfile();
                        }}
                        className="btn btn-primary mt-5"
                      >
                        update
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          addProfile();
                        }}
                        className="btn btn-primary mt-5"
                      >
                        Add
                      </button>
                    )}
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-sm-2">
                    <label className="col-form-label" htmlFor="val-range">
                      Driving Licence images
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e, "dl1");
                      }}
                    />
                    <div className="row">
                      {(riderData.riderDLImages &&
                        riderData.riderDLImages[0]) ||
                      dlImg ? (
                        <>
                          <div
                            onClick={() => {
                              viewImage(riderData.riderDLImages[0]);
                            }}
                            className="col-sm-8"
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                          >
                            <img
                              alt=""
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={dlImg ? dlImg : riderData.riderDLImages[0]}
                            />
                          </div>
                          {/* {riderData.riderDLImages &&
                          riderData.riderDLImages[0] ? (
                            <div className="col-sm-2 mt-4">
                              <Link
                                onClick={() => {
                                  deleteDl("dl1");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            </div>
                          ) : null} */}
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e, "dl2");
                      }}
                    />
                    <div className="row">
                      {(riderData.riderDLImages &&
                        riderData.riderDLImages[1]) ||
                      dlImg2 ? (
                        <>
                          <div
                            onClick={() => {
                              viewImage(riderData.riderDLImages[1]);
                            }}
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="col-sm-8"
                          >
                            <img
                              alt=""
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              className="playerProfilePic_home_tile"
                              src={dlImg2 ? dlImg2 : riderData.riderDLImages[1]}
                            />
                          </div>
                          {/* <div className="col-sm-2 mt-4">
                            {riderData.riderDLImages &&
                            riderData.riderDLImages[1] ? (
                              <Link
                                onClick={() => {
                                  deleteDl("dl2");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            ) : null}
                          </div> */}
                        </>
                      ) : null}
                    </div>
                  </div>
                  {/* <div className="mt-5">
                    {riderData.riderDLImages &&
                    riderData.riderDLImages[0] &&
                    riderData.riderDLImages[1] ? (
                      <button
                        onClick={() => {
                          updateDlImage();
                        }}
                        className="btn btn-primary mt-3"
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          AddDlImage();
                        }}
                        className="btn btn-primary mt-3 ml-4 "
                      >
                        Add
                      </button>
                    )}
                  </div> */}
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        updateDlImage();
                      }}
                      className="btn btn-primary mt-3"
                    >
                      Update
                    </button>
                  </div>
                </div>
                {riderData.RiderVehicleType &&
                  riderData.RiderVehicleType.category !== "two-wheeler" && (
                    <div className="row mt-4">
                      <div className="col-sm-2">
                        <label className="col-form-label" htmlFor="val-range">
                          Registration Certificate Image
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-sm-4">
                        <input
                          className="col-sm-12"
                          id="profilePic"
                          type="file"
                          onChange={(e) => {
                            onChangePicture(e, "rc1");
                          }}
                        />

                        <div className="row">
                          {(riderData.riderVechicleRCImages &&
                            riderData.riderVechicleRCImages[0]) ||
                          rcImg ? (
                            <>
                              <div
                                onClick={() => {
                                  viewImage(riderData.riderVechicleRCImages[0]);
                                }}
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="col-sm-8"
                              >
                                <img
                                  alt=""
                                  className="playerProfilePic_home_tile"
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={
                                    rcImg == null
                                      ? riderData.riderVechicleRCImages[0]
                                      : rcImg
                                  }
                                />
                              </div>
                              {/* <div className="col-sm-2 mt-4">
                            {riderData.riderVechicleRCImages &&
                            riderData.riderVechicleRCImages[0] ? (
                              <Link
                                onClick={() => {
                                  deleteRc("rc1");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            ) : null}
                          </div> */}
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <input
                          className="col-sm-12"
                          id="profilePic"
                          type="file"
                          onChange={(e) => {
                            onChangePicture(e, "rc2");
                          }}
                        />

                        <div className="row">
                          {(riderData.riderVechicleRCImages &&
                            riderData.riderVechicleRCImages[1]) ||
                          rcImg2 ? (
                            <>
                              <div
                                onClick={() => {
                                  viewImage(riderData.riderVechicleRCImages[1]);
                                }}
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="col-sm-8"
                              >
                                <img
                                  alt=""
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  className="playerProfilePic_home_tile"
                                  src={
                                    rcImg2 == null
                                      ? riderData.riderVechicleRCImages[1]
                                      : rcImg2
                                  }
                                />
                              </div>
                              {/* <div className="col-sm-2 mt-4">
                            {riderData.riderVechicleRCImages &&
                            riderData.riderVechicleRCImages[1] ? (
                              <Link
                                onClick={() => {
                                  deleteRc("rc2");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            ) : null}
                          </div> */}
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className="mt-5">
                        <button
                          onClick={() => {
                            updateRCImage();
                          }}
                          className="btn btn-primary mt-3 "
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  )}

                <div className="row mt-4">
                  <div className="col-sm-2">
                    <label className="col-form-label">
                      Identity Proof
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e, "id1");
                      }}
                    />
                    <div className="row">
                      {(riderData.riderIdProofImage &&
                        riderData.riderIdProofImage[0]) ||
                      idImg ? (
                        <>
                          <div
                            onClick={() => {
                              viewImage(riderData.riderIdProofImage[0]);
                            }}
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="col-sm-8"
                          >
                            <img
                              alt=""
                              className="playerProfilePic_home_tile"
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={
                                idImg == null
                                  ? riderData.riderIdProofImage[0]
                                  : idImg
                              }
                            />
                          </div>
                          {/* <div className="col-sm-2 mt-4">
                            {riderData.riderIdProofImage &&
                            riderData.riderIdProofImage[0] ? (
                              <Link
                                onClick={() => {
                                  deleteId("id1");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            ) : null}
                          </div> */}
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e, "id2");
                      }}
                    />
                    <div className="row">
                      {(riderData.riderIdProofImage &&
                        riderData.riderIdProofImage[1]) ||
                      idImg2 ? (
                        <>
                          <div
                            onClick={() => {
                              viewImage(riderData.riderIdProofImage[1]);
                            }}
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="col-sm-8"
                          >
                            <img
                              alt=""
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              className="playerProfilePic_home_tile"
                              src={
                                idImg2 == null
                                  ? riderData.riderIdProofImage[1]
                                  : idImg2
                              }
                            />
                          </div>
                          {/* <div className="col-sm-2 mt-4">
                            {riderData.riderIdProofImage &&
                            riderData.riderIdProofImage[1] ? (
                              <Link
                                onClick={() => {
                                  deleteId("id2");
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp mt-3"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                            ) : null}
                          </div> */}
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        updateIDImage();
                      }}
                      className="btn btn-primary mt-3"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-2">
                    <label className="col-form-label">
                      Vehicle Images
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-8">
                    <input
                      className="col-sm-12"
                      id="profilePic"
                      multiple
                      type="file"
                      onChange={(e) => {
                        onChangePicture(e, "vehicle");
                      }}
                    />
                    {vehicleImg && (
                      <div
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                      >
                        <img
                          alt=""
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                            flexDirection: "row",
                          }}
                          src={vehicleImg}
                        />
                      </div>
                    )}
                    <div className="row">
                      {riderData.riderVechicleImages &&
                        riderData.riderVechicleImages.map((val, idx) => {
                          return (
                            <>
                              <div
                                onClick={() => {
                                  viewImage(val);
                                }}
                                className="col-sm-3"
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                              >
                                <img
                                  alt=""
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                    flexDirection: "row",
                                  }}
                                  src={val}
                                />
                              </div>
                              <div>
                                <div>
                                  <Link
                                    onClick={() => {
                                      updateVehicleImage(val, idx);
                                    }}
                                    href="#"
                                    className="btn btn-warning shadow btn-xs sharp mt-5"
                                  >
                                    <i className="fa fa-pencil"></i>
                                  </Link>
                                </div>
                                {/* <div>
                                  <Link
                                    onClick={() => {
                                      deleteVehicleImage(val);
                                    }}
                                    href="#"
                                    className="btn btn-danger shadow btn-xs sharp mt-2"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </div> */}
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                  {/* <div className="mt-5">
                    {riderData.riderVechicleImages &&
                      riderData.riderVechicleImages.length < 6 && (
                        <button
                          onClick={() => {
                            addVehicleImage();
                          }}
                          className="btn btn-primary mt-3"
                        >
                          Add
                        </button>
                      )}
                  </div> */}
                </div>
                <div className="row mt-4">
                  <div className="col-sm-2"></div>
                  <div className="col-sm-8">
                    <small class="text-white ">
                      Choose the file and click pencil icon of which image you
                      want to update
                    </small>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditRider;
